var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import { StyledSelect } from 'pages/Member/Tabs/Overview/sections/styled';
import enumCollections from 'constants/enumCollections';
var EnumSelect = function (props) {
    var _a;
    var enum_name = props.enum_name, isMemberSelect = props.isMemberSelect, showSearch = props.showSearch, restProps = __rest(props, ["enum_name", "isMemberSelect", "showSearch"]);
    var hideValues = restProps.hideValues, showAll = restProps.showAll, filterFn = restProps.filterFn;
    // Removing these props to avoid React warnings
    delete restProps.showAll;
    delete restProps.filterFn;
    var values = ((_a = enumCollections[enum_name]) === null || _a === void 0 ? void 0 : _a.enumValues) || [];
    var enumValues = hideValues
        ? values.filter(function (value) { return !(hideValues === null || hideValues === void 0 ? void 0 : hideValues.has(value.name)); })
        : values;
    // Enums have pairs of name and description. Currently searching by description.
    var options = enumValues.map(function (item) { return ({
        key: item.name,
        value: item.name,
        label: item.description,
        disabled: filterFn ? !filterFn(item) : false
    }); });
    if (showAll) {
        options.push({ value: null, label: 'All', key: 'All' });
    }
    // Disabled items go to the end of the list
    var sortedOptions = options.sort(function (a) {
        if (a.disabled)
            return 1;
        return -1;
    });
    var showSearchConfig = showSearch === false
        ? false
        : __assign({ optionFilterProp: 'label' }, (typeof showSearch === 'object' && showSearch));
    if (isMemberSelect)
        return (_jsx(StyledSelect, __assign({ showSearch: showSearchConfig, options: sortedOptions }, restProps)));
    return (_jsx(Select, __assign({ showSearch: showSearchConfig, options: sortedOptions }, restProps)));
};
export default EnumSelect;
